export default [
      {
        path: '/admin/parametritation',
        name: 'admin-parametritation',
        component: () => import('@/views/admin/parametritation/Parametritation.vue'),
        meta: {
          resource: 'apart-settings.view',
          action: 'read',
          pageTitle: 'Parametrizacion'
        },
      },
      {
        path: '/admin/createParametritation/:id',
        name: 'admin-createParametritation',
        component: () => import('@/views/admin/parametritation/CreateParametritation.vue'),
        meta: {
          resource: 'apart-settings.view',
          action: 'read',
          pageTitle: 'Crear Parametrizacion'
        },
      },
      {
        path: '/admin/coverages',
        name: 'admin-coverages',
        component: () => import('@/views/admin/coverages/CoveragesView.vue'),
        meta: {
          resource: 'coverages.view',
          action: 'read',
          pageTitle: 'Zonas de cobertura'
        },
      },
    ]
    